import React from 'react';
// We can keep your existing CSS imports if they exist, 
// but we will add inline styles or a specific class to force the z-index.
import './style/shared.css';
import './style/upload.css';

const VerificationModal = ({ isOpen, onClose }) => {
  
  if (!isOpen) return null;

  const navigateToSettings = () => {
    window.location.href = '/settings';
  };

  // Inline style to force this modal to be on top of everything else
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 99999, // <--- CRITICAL FIX: Extremely high z-index
    backdropFilter: 'blur(2px)'
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div className="widget-container" onClick={(e) => e.stopPropagation()}>
        
        <div className="widget-header">
          <h2>Security Alert</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        
        <div className="widget-content">
          <div className="status-container unregistered-state">
            <div className="icon-circle warning-bg">
              {/* Shield Icon */}
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                <path d="M8 11h8"></path>
                <path d="M12 11v4"></path>
              </svg>
            </div>
            
            <h3>Device Verification Required</h3>
            
            <p className="main-message">
              This device is not recognised by our security system.
            </p>
            
            <div className="info-box">
              <span className="info-icon">ℹ️</span>
              <p>To perform this action, you must register this device (Passkey, FaceID, or TouchID) in your settings.</p>
            </div>

            <button className="action-btn primary full-width" onClick={navigateToSettings}>
              Register Device in Settings &rarr;
            </button>
            
            <button className="link-btn" onClick={onClose}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationModal;
